import * as ChangeInvestorTypeTypes from 'src/actions/investor-type/change-data/Types';
import {
  ChangeInvestorType,
  ChangeInvestorTypeAction
} from 'src/actions/investor-type/change-data/ChangeInvestorType.actions';
import InvestorType from 'src/entities/InvestorType';

export interface ChangeInvestorTypeState {
  investorType?: InvestorType;
  loading: boolean;
}

const initialState: ChangeInvestorTypeState = {
  loading: false
};

export function ChangeInvestorTypeReducer(state: ChangeInvestorTypeState = initialState,
                                          action: ChangeInvestorTypeAction):
  ChangeInvestorTypeState {
  switch (action.type) {
    case ChangeInvestorTypeTypes.CHANGE_INVESTOR_TYPE_DATA:
      const investorType: InvestorType = (
        action as ChangeInvestorType).payload;
      return {...state, investorType: investorType, loading: false};
    default:
      return state;
  }
}



// WEBPACK FOOTER //
// ./src/reducers/investor-type/ChangeInvestorTypeReducer.tsx